module.exports = __webpack_public_path__ + "static/media/planning-name.8129ca09.svg";